import type { BetslipEvent } from '../contexts/BetslipContext';
import type { BetBuilderLegListItem } from '../components/molecules/BetBuilderLegList';
import { mapBetBuilderSelectionsToLegs, mapMyBetsSelectionToLeg } from '../utils/betBuilder';
import type { BetBuilderMyBetsGroup } from '../types/betBuilder';

type BetBuilderItemInput = { type: 'betslip'; bet: BetslipEvent } | { type: 'myBets'; group: BetBuilderMyBetsGroup };

type UseBetBuilderItemResult = {
  legs: BetBuilderLegListItem[];
};

export const useBetBuilderItem = (input: BetBuilderItemInput): UseBetBuilderItemResult => {
  if (input.type === 'betslip') {
    const { bet } = input;
    const legs = bet.betBuilder ? mapBetBuilderSelectionsToLegs(bet.betBuilder.selections) : [];

    return { legs };
  }

  const { group } = input;
  const legs = mapMyBetsSelectionToLeg(group);

  return { legs };
};
